module.exports = __webpack_public_path__ + "img/744.a79dd221.jpg";